/**
 * Copyright (C) 2025 GIP-RECIA, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import type { IconDefinition } from '@fortawesome/fontawesome-common-types'
import type { Link } from 'common/types/index.ts'

export enum UserMenuItem {
  Search = 'search',
  Notification = 'notification',
  Account = 'account',
  InfoEtab = 'info-etab',
  ChangeEtab = 'change-etab',
  Starter = 'starter',
  Logout = 'logout',
}

export type UserMenuConfig = Record<
  UserMenuItem,
  false | undefined | {
    icon?: IconDefinition
    link?: Link | null
  }
>

export interface UserMenu {
  'picture'?: string
  'display-name'?: string
  'function'?: string
  'config'?: Partial<UserMenuConfig>
  'notification'?: number
  'avatar-size'?: string
}
